import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Divide: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['circle', { cx: '12', cy: '6', r: '1' }],
    ['line', { x1: '5', x2: '19', y1: '12', y2: '12' }],
    ['circle', { cx: '12', cy: '18', r: '1' }],
  ],
];

export default Divide;
